const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Saakshi</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate Registration Head, UPES-CSI</li>
    <li>
        Supporting registration operations.
    </li>
    <li>
        Ensuring efficient participant management.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
